<mat-icon *repeatElement="iconCount" color="warn">local_fire_department</mat-icon>
